import { Box, ListItemText, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import propTypes from 'prop-types';
import { setB, setButtons, setLinks } from '../../../utils/utils';
import { messagesTypes } from '../../../constants/ChatMessages';
import moment from 'moment';
import { isArray } from 'lodash';
import { PictureAsPdf } from '@mui/icons-material';
import { useFirebase } from 'react-redux-firebase';

const useStyles = (small, openHeader) => {
  return makeStyles((theme) => ({
    chatFontSize: {
      fontSize: '0.85rem !important',
    },
    textGray: {
      color: '#a3a3a3',
    },
    notification: {
      whiteSpace: 'pre-line',
      marginLeft: 'auto',
      float: 'right',
      background: '#b1d3e3',
      color: theme.palette.black.dark,
      maxWidth: '90%',
      width: 'fit-content',
    },
    user: {
      whiteSpace: 'pre-line',
      float: 'right',
      background: '#fff3cf',
      color: theme.palette.black.dark,
      maxWidth: '90%',
      width: 'fit-content',
      marginLeft: 'auto',
    },
    chatText: {
      display: 'inline-block',
      clear: 'both',
      padding: '10px',
      paddingTop: '5px',
      paddingBottom: '5px',
      // borderRadius: '15px',
      marginBottom: '8px',
      marginTop: '8px',
    },
    chatImage: {
      display: 'inline-block',
      clear: 'both',
      padding: '10px',
      paddingTop: '5px',
      paddingBottom: '5px',
      // borderRadius: '15px',
      marginBottom: '2px',
      marginTop: '2px',
      '& img': {
        cursor: 'pointer',
        maxHeight: '300px',
      },
      '& span': {
        overflow: 'hidden',
      },
    },
    himFake: {
      whiteSpace: 'pre-line',
      background: '#e3bce2',
      float: 'left',
      maxWidth: '90%',
    },
    him: {
      whiteSpace: 'pre-line',
      background: '#eee',
      float: 'left',
      maxWidth: '90%',
      width: 'fit-content',
      borderRadius: '12px 12px 12px 0',
    },
    me: {
      whiteSpace: 'pre-line',
      marginLeft: 'auto',
      float: 'right',
      background: '#DDF8C5',
      color: theme.palette.black.dark,
      maxWidth: '90%',
      width: 'fit-content',
      borderRadius: '12px 12px 0 12px',
    },
  }));
};

function Message(props) {
  const { message, chat, setModalOpen, setModalContent, cacheFiles } = props;
  const firebase = useFirebase();
  const ref = firebase.storage().ref();

  const handleModalOpen = (imageBase64) => {
    setModalContent(imageBase64);
    setModalOpen(true);
  };

  // define styles
  const small = useMediaQuery('(max-width:600px)');
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles(small)();

  // decide if message if left or right
  const sideClass =
    message.type === messagesTypes.client
      ? message.email
        ? classes.himFake
        : classes.him
      : message.type === messagesTypes.user
      ? classes.user
      : message.isNotification || message.isPanelMessage
      ? classes.notification
      : classes.me;
  const sentTime = `${moment(message.creationDate.toDate()).format('HH:mm')} - ${moment(
    message.creationDate.toDate(),
  ).format('DD/MM/YY')}`;
  const textMessage =
    message.type === 1
      ? setButtons(setLinks(setB(message.message)))
      : setButtons(setLinks(setB(message.message)));

  if (message.contentType === 'image') {
    let imageURL = message.message;
    if (message.hasDownload) {
      imageURL = cacheFiles.find((e) => e.id === message.message)?.url;
    }
    return (
      <ListItemText
        primary={
          <>
            <img
              src={
                message.hasDownload || message.message.indexOf('http') !== -1
                  ? imageURL
                  : `data:image/png;base64,${message.message}`
              }
              alt=""
            />
            <Typography>{message.caption || ''}</Typography>
          </>
        }
        secondary={sentTime}
        className={`${classes.chatImage} ${sideClass}`}
        onClick={() =>
          handleModalOpen(
            message.hasDownload || message.message.indexOf('http') !== -1
              ? imageURL
              : `data:image/png;base64,${message.message}`,
          )
        }
      />
    );
  } else if (message.contentType === 'file') {
    return (
      <ListItemText
        primary={
          <PictureAsPdf
            sx={{
              fontSize: '32px',
              cursor: 'pointer',
              transition: 'all .3s',
              '&:hover': { color: '#9c27b0', transform: 'scale(1.1)' },
            }}
          />
        }
        secondary={sentTime}
        className={`${classes.chatImage} ${sideClass}`}
        onClick={() => {
          const route = `files/${message.message}`;
          // TODO: ESTO SE VA A DEPRECAR MÁS ADELANTE Y SOLO QUEDARÁ window.open(message.message);
          if (message.hasDownload) {
            ref
              .child(route)
              .getDownloadURL()
              .then((url) => {
                window.open(url);
              });
          } else {
            window.open(message.message);
          }
        }}
      />
    );
  } else if (message.contentType === 'audio') {
    const record = cacheFiles.find((e) => e.id === message.message);
    return (
      <ListItemText
        key={record && record.url}
        primary={
          <Box>
            <audio controls>
              <source src={(record && record.url) || ''} type="audio/mpeg" />
            </audio>
            <br />
            <span className={`${classes.chatFontSize} ${classes.textGray}`}>
              {message.audioTranscription}
            </span>
          </Box>
        }
        className={`${classes.chatText} ${sideClass}`}
        sx={{
          flex: 'inherit',
        }}
      />
    );
  } else {
    const reason = message.reason;
    return (
      <Box position="relative">
        {reason && (
          <Box position="absolute" top={16} {...(message?.type === 2 ? { right: 0 } : { left: 0 })}>
            <Box
              sx={{
                background: '#e13131',
                color: 'white !important',
                padding: '4px 16px',
                borderRadius: '3rem',
                fontSize: 12,
              }}
            >
              {reason}
            </Box>
          </Box>
        )}
        <ListItemText
          primary={
            <span
              className={classes.chatFontSize}
              dangerouslySetInnerHTML={{ __html: textMessage }}
            />
          }
          secondary={`${message.email ? message.email : ''} ${sentTime}`}
          className={`${classes.chatText} ${sideClass}`}
          secondaryTypographyProps={
            chat.training &&
            chat.trainingTime &&
            isArray(chat.trainingTime) &&
            chat.trainingTime.find(
              (e) =>
                e - message.creationDate.seconds * 1000 > 0 &&
                e - message.creationDate.seconds * 1000 <= 3000,
            )
              ? { sx: { color: 'white !important' } }
              : {}
          }
          sx={
            chat.training &&
            chat.trainingTime &&
            isArray(chat.trainingTime) &&
            chat.trainingTime.find(
              (e) =>
                e - message.creationDate.seconds * 1000 > 0 &&
                e - message.creationDate.seconds * 1000 <= 3000,
            )
              ? { background: '#ff6666 !important', color: 'white !important' }
              : {}
          }
        />
      </Box>
    );
  }
}

const Props = {
  chat: propTypes.object,
  message: propTypes.object,
  setModalOpen: propTypes.func,
  setModalContent: propTypes.func,
  cacheFiles: propTypes.array,
};

Message.propTypes = Props;

export default Message;
